export enum ColumnDataTypeEnum {

    MONEY = "money",
    DECIMAL = "decimal",
    NUMBER = "number",
    DECIMAL_OR_INT = "decimal_or_int",
    DATE = "date",
    TRANSLATE = "translate",
    BOOLEAN = "boolean",
    BALANCE = "balance",
    STATUS = "status",
    LOG_TYPE = "logType",
    IMAGE_URL = "imageUrl",
    STOCK_STATUS = "stockStatus"

}